var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFuel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.d{fill:none;}.a,.c,.d{fill-rule:evenodd;}.b,.c{fill:#e6007e;}.d{stroke:#e6007e;stroke-width:1.2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H24V24H0Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.8 2)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8,7A1.075,1.075,0,0,0,7,6H1A1.075,1.075,0,0,0,0,7V20H8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M4,6A3,3,0,1,0,1,3,3,3,0,0,0,4,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M9.086,3.917l2,7.5a22.519,22.519,0,0,1,1,4.5,1.467,1.467,0,0,1-1.5,1.5,1.326,1.326,0,0,1-1.5-1.5v-5c0-1-.5-1.5-1-1.5h-1.5"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuel);
export default __webpack_public_path__ + "static/media/fuel.da5c4a07f59f062e9739fb0536d2209d.svg";
export { ForwardRef as ReactComponent };